import React, { useState, useEffect } from "react";
import goldIcon from "../../../../assets/icons/asset-icons/gold.svg";
import TransactionTypeBadge from "../../../pages/MainScreens/Transactions/TransactionTypeBadge/TransactionTypeBadge";
import Button from "../../Button/Button";
import Modal from "../Modal/Modal";
import styles from "../OrderDetails/OrderDetails.module.scss";
import {
  getPtpOrderDetailAction,
  getTransactionDetailsAction,
} from "../../../../features/user/userSlice";
import { useDispatch } from "react-redux";
import { format } from "date-fns";
import { formatPrice } from "../../../../utils/utils";
import Tooltip from "../../Tooltip/Tooltip";
import CopyBtn from "../../CopyBtn/CopyBtn";


// status
// inprogress - primary
// shipped - primary
// delivered - primary
// completed - green
const PtpOrderDetails = ({ show, handleClose, orderId }) => {
  const dispatch = useDispatch();

  const [transactionDetails, setTransactionDetails] = useState([]);
  // const [imageURL, setImageURL] = useState("");
  const [loading, setLoading] = useState(true);

  const getDetails = async () => {
    setLoading(true);
    try {
      const dataObj = {
        orderId: orderId.orderId,
      };
      const response = await dispatch(getPtpOrderDetailAction(dataObj));
      if (response.status === 200) {
        setTransactionDetails(response?.data?.data[0]);
        // setImageURL(response.data.data.imageUrl);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show) {
      getDetails();
    }
  }, [show]);

  return (
    <Modal
      show={show}
      handleClose={handleClose}
      className={styles.order_details}
      title="Order Details"
    >
      <ul>
        <li>
          <h6>Order Id:</h6>
          <h6>
            <Tooltip
              icon={<span>{transactionDetails?.order_id}</span>}
              content={
                <>
                  <CopyBtn text={transactionDetails?.order_id} />{" "}
                  {transactionDetails?.order_id}
                </>
              }
            />
          </h6>
        </li>
        <li>
          <h6>Status:</h6>
          <h6>
            <TransactionTypeBadge type="green">
              {transactionDetails?.status?.toLowerCase()}
            </TransactionTypeBadge>
          </h6>
        </li>
        <li>
          <h6>Price:</h6>
          <h6>${formatPrice(Number(transactionDetails?.price))}</h6>
          {/* {Number(productData?.quantity).toFixed(0) || 0} */}
        </li>
      </ul>
      {/* <ul>
        <li>
          <h6>From:</h6>
          <h6>Gold STBL</h6>
        </li>
        <li>
          <h6>To:</h6>
          <h6></h6>
        </li>
        <li>
          <h6>Total: </h6>
          <h6>${Number(transactionDetails?.price)?.toFixed(2)}</h6>
        </li>
      </ul> */}
      <ul>
        <li>
          <h6>Payment method:</h6>
          <h6>
            {/* <img src={goldIcon} alt="Gold-stbl" /> */}
            {/* {transactionDetails?.order_redemption_tracking?.payment_method} */}
            FIAT
          </h6>
        </li>
        <li>
          <h6>Date:</h6>
          <h6>
            {transactionDetails?.created_at &&
              format(new Date(transactionDetails?.created_at), "dd MMM, yyyy")}
          </h6>
        </li>
      </ul>
      <Button className={styles.continue_btn} onClick={handleClose} fluid>
        Continue
      </Button>
    </Modal>
  );
};

export default PtpOrderDetails;
